import { render, staticRenderFns } from "./ListWines.vue?vue&type=template&id=f5ea5f34&scoped=true&"
import script from "./ListWines.vue?vue&type=script&lang=js&"
export * from "./ListWines.vue?vue&type=script&lang=js&"
import style0 from "./ListWines.vue?vue&type=style&index=0&id=f5ea5f34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ea5f34",
  null
  
)

export default component.exports